import { FormGroup } from '@angular/forms';
import { HtmlControl } from './html-control.model';

export class FormSet {
  SetId: number;
  SetControls: HtmlControl[][] = new Array<HtmlControl[]>();
  SetForm: FormGroup;
  CurrentStepForSet: string;
}
